import { InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import type { Customer } from '../Customer'
import { QueryArgs } from '../../action'

@InputType()
export class GetCompanyUpsAccountsArgs extends QueryArgs<Customer> {}

export interface IGetCompanyUpsAccounts extends IAction<Customer[], GetCompanyUpsAccountsArgs> {}
